import AppStoreButtons from './AppStoreButtons.vue'

export default AppStoreButtons
